<template>
  <Card :title="title">
    <p class="mb-4 text-gray-700">This is where an AI Output Would Exist</p>

    <!-- Redesigned Button to Match the Insight Panel -->
    <router-link
      :to="`/${id}/backups`"
      class="inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200"
    >
      View Detailed Backup Reports
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="ml-2 h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M5 12h14M12 5l7 7-7 7" />
      </svg>
    </router-link>
  </Card>
</template>

<script>
import Card from '../Card.vue'

export default {
  name: 'BackupCard',
  components: {
    Card
  },
  props: {
    title: {
      type: String,
      default: 'Backup Details'
    },
    id: {
      type: [String, Number],
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/AICards/BackupCard.vue